import VideoJsConfigDirector from 'src/builders/VideoJsConfigDirector';
import { IApplicationData } from 'src/interfaces/ApplicationData';
import { TRANSMISSION_TYPE } from 'src/interfaces/enums';
import LivePlayer from '../entities/LivePlayer';
import VodPlayer from '../entities/VodPlayer';
import VideoJsLiveGateway from '../gateways/VideoJsLiveGateway';
import VideoJsVodGateway from '../gateways/VideoJsVodGateway';
import { IPlayerFactory } from './PlayerFactory';

class VideoJsPlayerFactory implements IPlayerFactory {
  private applicationData: Readonly<IApplicationData>;

  constructor(applicationData: IApplicationData) {
    this.applicationData = applicationData;
  }

  createPlayer(type: TRANSMISSION_TYPE, playerElement: HTMLVideoElement, callback?: () => void) {
    return this[type](playerElement, callback);
  }

  private live(playerElement: HTMLVideoElement, callback?: () => void) {
    return new LivePlayer(new VideoJsLiveGateway(playerElement, this.getPlayerConfig(), callback));
  }

  private vod(playerElement: HTMLVideoElement, callback?: () => void) {
    return new VodPlayer(new VideoJsVodGateway(playerElement, this.getPlayerConfig(), callback));
  }

  getPlayerConfig() {
    const { applicationData } = this;

    const videojsConfigDirector = new VideoJsConfigDirector(applicationData);
    return videojsConfigDirector.buildVideoJsConfig();
  }
}

export default VideoJsPlayerFactory;
